import { render } from "./_AccountsMobile.vue?vue&type=template&id=c210df0a"
import script from "./_AccountsMobile.vue?vue&type=script&lang=js"
export * from "./_AccountsMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__